
import * as reducer from './reducers';

import * as projectSectorsTypes from './types';
import * as projectSectorsActions from './actions';
import * as projectSectorsEpics from './epics';
import * as projectSectorsSelectors from './selectors';

export { projectSectorsTypes, projectSectorsActions, projectSectorsEpics, projectSectorsSelectors };

export default reducer;

